import React from 'react';
import PropTypes from 'prop-types';
import {Field, Form} from 'formik';

import {useNavigate} from 'react-router-dom';

import SubmitFormGroup from 'components/SubmitFormGroup';

import {Box, SimpleGrid} from '@mantine/core';

import {PacFormikInput} from 'pac-platform-ui-components';

import {I18n} from '@aws-amplify/core';


const FormComponent = (props) => {
    const navigate = useNavigate();

    return (
        <Form onReset={props.handleReset} onSubmit={props.handleSubmit}>
            <SimpleGrid>
                <Box mt="sm">
                    <Field
                        autoFocus
                        tabIndex={1}
                        type="email"
                        description={I18n.get('Enter your work email address, e.g. myname@mycompany.com')}
                        placeholder={I18n.get('Work Email Address')}
                        name="email"
                        id="email"
                        onChange={props.handleChange}
                        component={PacFormikInput}
                    />
                </Box>

                <SubmitFormGroup
                    tabIndex={2}
                    cancelUrl="/"
                    disabled={props.isSubmitting}
                    submitButtonLabel={I18n.get('Next')}
                />
            </SimpleGrid>
        </Form>
    );
};

FormComponent.propTypes = {
    handleSubmit: PropTypes.func,
    handleReset: PropTypes.func,
    handleChange: PropTypes.func,
    isSubmitting: PropTypes.bool,
};

export default FormComponent;
